import api from './api.js';

export const admissionService = {
  // Submit admission application
  submitApplication: (formData) => api.post('/academic/admission-applications', formData),
  
  // Upload documents
  uploadDocuments: (formData) => api.post('/academic/admission-applications/documents/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  
  // Get application by ID
  getApplication: (id) => api.get(`/academic/admission-applications/${id}`),
  
  // Get application status
  getApplicationStatus: (applicationNumber) => 
    api.get(`/academic/admission-applications/status/${applicationNumber}`),
  
  // Update application
  updateApplication: (id, data) => api.put(`/academic/admission-applications/${id}`, data),
  
  // Save draft application
  saveDraft: (data) => api.post('/academic/admission-applications/draft', data),
  
  // Get draft application
  getDraft: (userId) => api.get('/academic/admission-applications/draft'),
  
  // Delete draft application
  deleteDraft: (userId) => api.delete('/academic/admission-applications/draft'),
  
  // Get admission requirements
  getRequirements: () => api.get('/academic/admission-applications/requirements'),
  
  // Get available classes
  getAvailableClasses: () => api.get('/academic/classes'),
  
  // Get admission fees
  getAdmissionFees: () => api.get('/academic/admission-applications/fees'),
  
  // Check application number availability
  checkApplicationNumber: (number) => 
    api.get(`/academic/admission-applications/check-number/${number}`),
  
  // Generate application number
  generateApplicationNumber: () => api.post('/academic/admission-applications/generate-number'),
  
  // Get admission statistics
  getAdmissionStats: () => api.get('/academic/admission-applications/statistics'),
  
  // Get admission deadlines
  getAdmissionDeadlines: () => api.get('/academic/admission-applications/deadlines'),
  
  // Send application confirmation email
  sendConfirmationEmail: (applicationId) => 
    api.post(`/academic/admission-applications/${applicationId}/send-confirmation`),
  
  // Get interview schedule
  getInterviewSchedule: (applicationId) => 
    api.get(`/academic/admission-applications/${applicationId}/interview`),
  
  // Schedule interview
  scheduleInterview: (applicationId, data) => 
    api.post(`/academic/admission-applications/${applicationId}/interview`, data),
  
  // Reschedule interview
  rescheduleInterview: (applicationId, data) => 
    api.put(`/academic/admission-applications/${applicationId}/interview`, data),
  
  // Cancel interview
  cancelInterview: (applicationId) => 
    api.delete(`/academic/admission-applications/${applicationId}/interview`),
  
  // Get admission results
  getAdmissionResults: (applicationId) => 
    api.get(`/academic/admission-applications/${applicationId}/result`),
  
  // Accept admission offer
  acceptOffer: (applicationId) => 
    api.post(`/academic/admission-applications/${applicationId}/accept`),
  
  // Decline admission offer
  declineOffer: (applicationId) => 
    api.post(`/academic/admission-applications/${applicationId}/decline`),
  
  // Get payment information
  getPaymentInfo: (applicationId) => 
    api.get(`/academic/admission-applications/${applicationId}/payment`),
  
  // Process payment
  processPayment: (applicationId, paymentData) => 
    api.post(`/academic/admission-applications/${applicationId}/payment`, paymentData),
  
  // Get payment status
  getPaymentStatus: (applicationId) => 
    api.get(`/academic/admission-applications/${applicationId}/payment/status`),
  
  // Download admission letter
  downloadAdmissionLetter: (applicationId) => 
    api.get(`/academic/admission-applications/${applicationId}/admission-letter`, {
      responseType: 'blob'
    }),
  
  // Download application receipt
  downloadReceipt: (applicationId) => 
    api.get(`/academic/admission-applications/${applicationId}/receipt`, {
      responseType: 'blob'
    }),
  
  // Get admission FAQs
  getFAQs: () => api.get('/academic/admission-applications/faqs'),
  
  // Submit FAQ question
  submitFAQQuestion: (data) => api.post('/academic/admission-applications/faqs/question', data),
  
  // Get admission announcements
  getAnnouncements: () => api.get('/academic/admission-applications/announcements'),
  
  // Get admission calendar
  getAdmissionCalendar: () => api.get('/academic/admission-applications/calendar'),
  
  // Get admission policies
  getAdmissionPolicies: () => api.get('/academic/admission-applications/policies'),
  
  // Get admission forms templates
  getFormTemplates: () => api.get('/academic/admission-applications/forms/templates'),
  
  // Download form template
  downloadFormTemplate: (templateId) => 
    api.get(`/academic/admission-applications/forms/templates/${templateId}/download`, {
      responseType: 'blob'
    }),
  
  // Submit feedback
  submitFeedback: (data) => api.post('/academic/admission-applications/feedback', data),
  
  // Get admission support
  getSupport: () => api.get('/academic/admission-applications/support'),
  
  // Contact admission office
  contactAdmissionOffice: (data) => api.post('/academic/admission-applications/contact', data),
};
